<template>
<button v-if="hasCallback" @click.prevent="callCallback" class="btn">Use</button>
</template>

<script>
export default {
  props: ["item"],
  data: ()=>({
  }),
  computed: {
    hasCallback() {
      return !!this.stores.callbacks.lastCallback;
    },
  },
  methods: {
    callCallback() {
      if (this.hasCallback) {
        this.stores.callbacks.lastCallback(this.item);
        this.$router.go(-1);
      }
    },
  },
}
</script>

